import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { Buckets } from '@fortem-monorepo/web-sdk'
import { API } from '@fortem-monorepo/web-sdk'

import { toastApiError } from '@/lib/error-toast'

export const useAddBucketMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Buckets.CreateBucketBody) => {
      return api.buckets.create(body)
    },
    onSuccess: (_data, _params) => {
      toast.success('Bucket created')
    },
  })
}

export const useUpdateBucketMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: API.UpdateBody) => {
      return api.buckets.update(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Successfully updated ${_params.oldValue} to ${_params.newValue}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error updating ${_params.oldValue} to ${_params.newValue}`)
    },
  })
}

export const useDeleteBucketMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (params: Buckets.DeleteBucketParams) => {
      return api.buckets.delete(params)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Successfully deleted bucket ${_params.bucket_id}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error deleting bucket ${_params.bucket_id}`)
    },
  })
}
